import{t as e}from"../../../../_virtual/taggedTemplateLiteralLoose.js";var t;(t=e).exports=function(e,t){return t||(t=e.slice(0)),e.raw=t,e},t.exports.__esModule=!0,t.exports.default=t.exports;
//# sourceMappingURL=taggedTemplateLiteralLoose.js.map
